export default __webpack_public_path__ + "static/gremlin-laugh-934da6b9877bd380b872c429a1c2355c.mp3";